import { locale_es } from "./translation.es";

export const locale_es_MX = {
    "lang": "es-MX",
    "data": locale_es.data
}